import { render, staticRenderFns } from "./BookMenu.vue?vue&type=template&id=521f5454&scoped=true&"
import script from "./BookMenu.vue?vue&type=script&lang=js&"
export * from "./BookMenu.vue?vue&type=script&lang=js&"
import style0 from "./BookMenu.vue?vue&type=style&index=0&id=521f5454&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521f5454",
  null
  
)

export default component.exports